<div class="wrapper_view" [style.backgroundColor]="value ? trueColor : falseColor" 
[style.width]="width" [style.height]="height" [style.borderColor]="borderColor">
    <span [style.color]="value ? trueTextColor : falseTextColor">{{ text }}</span>
</div>